module.exports = __webpack_public_path__ + "static/media/CoralStar.ac39415d.svg";